import { RefundsFilterSheetComponent } from './shared/ui/refunds-filter-sheet';
import { AccountingService } from './shared/services/accounting.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { accountingRouting } from './accounting.routing';
import { SharedModule } from '../shared/shared.module';
import {PaymentsFilterSheetComponent} from './shared';
import { ProfitLossFilterSheetComponent} from './shared';

import {
    MaterialFormsModule,
    MaterialUserInterfaceModule,
} from 'ng2-material-components/ng2-material-components';

import { AccountingComponent } from './accounting.component';

import { ProfitLossIndexComponent }   from './profit-loss';




import { PaymentIndexComponent }   from './payment';
import { PaymentDetailsComponent }   from './payment/payment-details';
import {PaymentMethodSummaryService} from './shared';
import { ChartsModule } from 'ng2-charts/ng2-charts';

import {ProfitIndexComponent} from './profit-loss/profit';
import {ProfitSummaryComponent} from './profit-loss/profit/profit-summary';
import {ProfitLocationComponent} from './profit-loss/profit/profit-location';
import {ProfitProductComponent} from './profit-loss/profit/profit-product';
import {ProfitEmployeeComponent} from './profit-loss/profit/profit-employee';

import {
    ProfitSummaryService,
    ProfitLocationSaleService,
    ProfitProductSaleService,
    ProfitEmployeeSaleService
} from './shared';

import {LossIndexComponent} from './profit-loss/loss';
import {LossSummaryComponent} from './profit-loss/loss/loss-summary';
import {LossCategoryComponent} from './profit-loss/loss/loss-category';
import {LossCostComponent} from './profit-loss/loss/loss-cost';
import {LossInventoryComponent} from './profit-loss/loss/loss-inventory';
import {LossPayrollComponent} from './profit-loss/loss/loss-payroll';
import { AccountingRefundsComponent } from './refunds/accounting-refunds.component';


import {
    LossExpenseCategoryService,
    LossCostSaleService,
    LossInventoryLossesService,
    LossPayrollService
}from './shared';

import {PieChartComponent, BarChartComponent} from './shared';




@NgModule({
    imports: [
        CommonModule,
        MaterialFormsModule,
        MaterialUserInterfaceModule,
        accountingRouting,
        SharedModule,
        ChartsModule
    ],
    exports: [
        AccountingComponent,

        PaymentIndexComponent,
        PaymentDetailsComponent,
        PaymentsFilterSheetComponent,

        ProfitLossIndexComponent,

        ProfitIndexComponent,
        ProfitSummaryComponent,
        ProfitLocationComponent,
        ProfitProductComponent,
        ProfitEmployeeComponent,

        LossIndexComponent,
        LossSummaryComponent,
        LossCategoryComponent,
        LossCostComponent,
        LossInventoryComponent,
        LossPayrollComponent,
        ProfitLossFilterSheetComponent,
        AccountingRefundsComponent,
        RefundsFilterSheetComponent,

        PieChartComponent,
        BarChartComponent
    ],
    declarations: [
        AccountingComponent,

        PaymentIndexComponent,
        PaymentDetailsComponent,
        PaymentsFilterSheetComponent,

        ProfitLossIndexComponent,

        ProfitIndexComponent,
        ProfitSummaryComponent,
        ProfitLocationComponent,
        ProfitProductComponent,
        ProfitEmployeeComponent,

        LossIndexComponent,
        LossSummaryComponent,
        LossCategoryComponent,
        LossCostComponent,
        LossInventoryComponent,
        LossPayrollComponent,
        ProfitLossFilterSheetComponent,
        AccountingRefundsComponent,
        RefundsFilterSheetComponent,

        PieChartComponent,
        BarChartComponent
    ],
    providers: [
        PaymentMethodSummaryService,
        ProfitSummaryService,
        ProfitLocationSaleService,
        ProfitProductSaleService,
        ProfitEmployeeSaleService,

        LossExpenseCategoryService,
        LossCostSaleService,
        LossInventoryLossesService,
        LossPayrollService,
        AccountingService
    ],
})
export class AccountingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/accounting.module.ts